/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Participation_Agreement_Date_LabelInputs */

const en_admin_participation_agreement_date_label = /** @type {(inputs: Admin_Participation_Agreement_Date_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version date`)
};

const de_admin_participation_agreement_date_label = /** @type {(inputs: Admin_Participation_Agreement_Date_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand-Datum`)
};

/**
* | output |
* | --- |
* | "Version date" |
*
* @param {Admin_Participation_Agreement_Date_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_participation_agreement_date_label = /** @type {((inputs?: Admin_Participation_Agreement_Date_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Participation_Agreement_Date_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_participation_agreement_date_label(inputs)
	return en_admin_participation_agreement_date_label(inputs)
});